import React from 'react';
import { FaSpaceShuttle, FaUsers, FaUser, FaUserFriends } from 'react-icons/fa';
import './ViewModeButtons.css';

interface ViewModeButtonsProps {
  isGrouped: boolean;
  setIsGrouped: (grouped: boolean) => void;
  selectedUser: string;
  setSelectedUser: (user: string) => void;
  username: string;
  viewType?: 'grid' | 'list' | 'catalog';
  setViewType?: (viewType: 'grid' | 'list' | 'catalog') => void;
  catalogSortBy?: 'manufacturer' | 'type' | 'name';
  setCatalogSortBy?: (sortBy: 'manufacturer' | 'type' | 'name') => void;
}

export const ViewModeButtons: React.FC<ViewModeButtonsProps> = ({
  isGrouped,
  setIsGrouped,
  selectedUser,
  setSelectedUser,
  username,
  viewType,
  setViewType,
  catalogSortBy,
  setCatalogSortBy
}) => {
  // Determinar si estamos en "Mi Flota" (selectedUser === username) o "Toda la Flota" (selectedUser === '')
  const isMyFleet = selectedUser === username && username !== '';

  return (
    <div className="view-mode-buttons">
      <div className="view-mode-group">
        <button
          className={`view-mode-button ${isMyFleet ? 'active' : ''}`}
          onClick={() => {
            if (isMyFleet) {
              // Si ya está en "Mi Flota", cambiar a "Toda la Flota"
              setSelectedUser('');
            } else {
              // Si está en "Toda la Flota", cambiar a "Mi Flota"
              setSelectedUser(username);
            }
          }}
          title="Ver solo mi flota"
        >
          <FaUser />
          <span>Mi Flota</span>
        </button>
        <button
          className={`view-mode-button ${!isMyFleet ? 'active' : ''}`}
          onClick={() => setSelectedUser('')}
          title="Ver toda la flota"
        >
          <FaUserFriends />
          <span>Toda la Flota</span>
        </button>
      </div>

      <div className="view-mode-group">
        <button
          className={`view-mode-button ${!isGrouped ? 'active' : ''}`}
          onClick={() => setIsGrouped(false)}
          title="Ver naves individuales"
          data-tutorial-target="individual-view-button"
        >
          <FaSpaceShuttle />
          <span>Individuales</span>
        </button>
        <button
          className={`view-mode-button ${isGrouped ? 'active' : ''}`}
          onClick={() => setIsGrouped(true)}
          title="Ver naves agrupadas"
        >
          <FaUsers />
          <span>Agrupadas</span>
        </button>
      </div>

      {viewType !== undefined && setViewType && (
        <div className="view-mode-group">
          <button
            className={`view-mode-button ${viewType === 'grid' ? 'active' : ''}`}
            onClick={() => setViewType('grid')}
            title="Vista de tarjetas"
          >
            <span>Tarjetas</span>
          </button>
          <button
            className={`view-mode-button ${viewType === 'list' ? 'active' : ''}`}
            onClick={() => setViewType('list')}
            title="Vista de lista"
          >
            <span>Lista</span>
          </button>
          <button
            className={`view-mode-button ${viewType === 'catalog' ? 'active' : ''}`}
            onClick={() => setViewType('catalog')}
            title="Vista de catálogo"
          >
            <span>Catálogo</span>
          </button>
          {viewType === 'catalog' && catalogSortBy && setCatalogSortBy && (
            <select
              value={catalogSortBy}
              onChange={(e) => setCatalogSortBy(e.target.value as 'manufacturer' | 'type' | 'name')}
              className="catalog-sort-select-inline"
              onClick={(e) => e.stopPropagation()}
            >
              <option value="manufacturer">Marca</option>
              <option value="type">Tipo de nave</option>
              <option value="name">Nombre</option>
            </select>
          )}
        </div>
      )}
    </div>
  );
};
